module.exports = __webpack_public_path__ + "img/BOTB_TraitRanks_Banner.79489efd.webp";